import { render, staticRenderFns } from "./TextBlockModal.vue?vue&type=template&id=0b204954&scoped=true"
import script from "./TextBlockModal.vue?vue&type=script&lang=js"
export * from "./TextBlockModal.vue?vue&type=script&lang=js"
import style0 from "./TextBlockModal.vue?vue&type=style&index=0&id=0b204954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b204954",
  null
  
)

export default component.exports